export default __webpack_public_path__ + "static/media/car-quality.fdf53fa9.png";